<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2023-02-22 16:07:11
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-08-13 10:46:19
 * @FilePath: \pigbox\src\views\Goods\Goods.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div style="width:100%;height:100%;">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>商品模板</span>
        <div
          style="width:30%;height:100%;display:flex;justify-content: space-between;  align-items: center;"
        >
          <span>商品类型:</span>
          <el-select v-model="chooseType" placeholder="请选择" @change="choosetTypeChange">
            <el-option v-for="item in typeChooseList" :label="item" :value="item"></el-option>
          </el-select>
          <el-button
            style="float: right; padding: 3px 0"
            type="text"
            @click="isShowAddPop=true"
          >添加商品</el-button>
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%" height="500px">
        <el-table-column label>
          <el-table-column prop="commodityName" label="商品名"></el-table-column>
          <el-table-column prop="commodityName" label="商品图片">
            <template slot-scope="scope">
              <el-image style="width: 50px; height: 50px" :src="scope.row.commodityPic"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="commodityPrice" label="价格"></el-table-column>
          <el-table-column prop="commodityStock" label="库存"></el-table-column>
          <el-table-column prop="commodityType" label="类别"></el-table-column>
          <el-table-column prop="commoditySf" label="规格"></el-table-column>
          <el-table-column prop="commodityBack" label="容量"></el-table-column>
        </el-table-column>
        <el-table-column prop="commodityType" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="warning" @click="delData(scope.row)">删除</el-button>
            <el-button size="mini" type="primary" @click="editDataHandler(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
  background
  layout="prev, pager, next"
  :total="1000">
</el-pagination>
    </el-card>
    <el-dialog title="修改" :visible.sync="showEidtPop" width="50%">
      <el-form :model="editData" label-width="100px">
        <el-form-item label="商品名">
          <el-input v-model="editData.commodityName"></el-input>
        </el-form-item>
        <el-form-item label="商品价格">
          <el-input v-model="editData.commodityPrice"></el-input>
        </el-form-item>
        <el-form-item label="商品库存">
          <el-input v-model="editData.commodityStock"></el-input>
        </el-form-item>
        <el-form-item label="商品类别">
          <el-input v-model="editData.commodityType"></el-input>
        </el-form-item>
        <el-form-item label="商品图片">
          <div class="myuploadimgbxo">
          <el-image
            style="width: 50px; height: 50px"
            :src="editData.commodityPic"
            :preview-src-list="srcList"
          ></el-image>
          <el-upload
          style="margin-left:15px"
            class="avatar-uploader"
            action="https://www.moodsci.com/pigbox/ExamineService/uploadPublicCommodityPicture"
            :show-file-list="false"
            :on-success="getImgUrl2"
          >
          
           <el-button type="primary" icon="el-icon-upload">修改图片</el-button>
          </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEidtPop = false">取 消</el-button>
        <el-button type="primary" @click="upLoadEdit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加商品" :visible.sync="isShowAddPop" width="50%">
      <el-form :model="addGoodList" label-width="100px">
        <el-form-item label="商品名">
          <el-input v-model="addGoodList.commodityName"></el-input>
        </el-form-item>
        <el-form-item label="商品价格">
          <el-input v-model="addGoodList.commodityPrice"></el-input>
        </el-form-item>
        <el-form-item label="商品库存">
          <el-input v-model="addGoodList.commodityStock"></el-input>
        </el-form-item>
        <el-form-item label="商品类别">
          <!-- <el-input v-model="addGoodList.commodityType"></el-input> -->
          <el-select v-model="addGoodList.commodityType" placeholder="请选择商品类别">
            <el-option :label="item" :value="item" v-for="item in haveTypeList"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品图片">
          <el-upload
            class="avatar-uploader"
            action="https://www.moodsci.com/pigbox/ExamineService/uploadPublicCommodityPicture"
            :show-file-list="false"
            :on-success="getImgUrl"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" style="width:100px;height:100px" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <!-- <el-image
            style="width: 50px; height: 50px"
            :src="editData.commodityPic"
            :preview-src-list="srcList"
          ></el-image>-->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowAddPop = false">取消</el-button>
        <el-button type="primary" @click="addGoodS">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      haveTypeList: [
        "日用",
        "零食",
        "粮油",
        "酒水",
        "饮料",
        "粮油",
        "文具",
        "玩具",
        "其他"
      ],
      typeChooseList: [
        {
          value: "酒水",
          label: "酒水"
        },
        {
          value: "饮料",
          label: "饮料"
        }
      ],
      chooseType: "雪糕",
      tableData: [],
      oldTbaleData: [],
      showEidtPop: false,
      editData: {},
      srcList: [],
      isShowAddPop: false,
      addGoodList: {
        commodityName: "",
        commodityPrice: "",
        commodityStock: "",
        commodityType: "",
        commodityPic: ""
      },
      imageUrl: "",
      // editImgurl:"",
    };
  },
  created() {
    this.getData();
  },
  methods: {
    choosetTypeChange(e) {
      // //console.log(e);
      let data = [...this.oldTbaleData];
      //console.log(data);
      let arr4 = data.filter(item => item.commodityType == e);
      // //console.log(arr4);
      this.tableData = arr4;
    },
    delData(data) {
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `ExamineService/detelePublicCommodity/${data.id}` // 接口地址
      }).then(res => {
        // //console.log(res);
        if (res == true) {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.getData();
        }
        // this.tableData = res;

        // }
      });
    },
    getImgUrl(e) {
      //console.log(e);
      this.imageUrl = "https://www.moodsci.com" + e;
    },
    getImgUrl2(e) {
      //console.log(e);
      this.editData.commodityPic = "https://www.moodsci.com" + e;
    },
    addGoodS() {
      // //console.log(this.addGoodList);
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `ExamineService/uploadPublicCommodity`, // 接口地址
        data: {
          commodity_name: this.addGoodList.commodityName,
          commodity_type: this.addGoodList.commodityType,
          commodity_pic: this.imageUrl,
          commodity_price: this.addGoodList.commodityPrice,
          commodity_stock: this.addGoodList.commodityStock
        }
      }).then(res => {
        this.isShowAddPop = false;
        // //console.log(res);
        if (res == true) {
          this.$message({
            message: "添加成功",
            type: "success"
          });
          this.getData();
        }
        // this.tableData = res;

        // }
      });
    },
    upLoadEdit() {
      //console.log(this.editData);
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `ExamineService/updatePublicCommodity`, // 接口地址
        data: {
          commodity_name: this.editData.commodityName,
          commodity_type: this.editData.commodityType,
          commodity_pic: this.editData.commodityPic,
          commodity_price: this.editData.commodityPrice,
          commodity_stock: this.editData.commodityStock,
          id: this.editData.id
        }
      }).then(res => {
        // //console.log(res);
        if (res == true) {
          this.getData();
          this.showEidtPop = false;
          this.$message({
            message: "修改成功",
            type: "success"
          });
        }

        // this.tableData = res;

        // }
      });
    },
    editDataHandler(data) {
      // //console.log(data);
      this.editData = data;
      this.srcList = [data.commodityPic];
      this.showEidtPop = true;

      //console.log(this.editData);
    },
    getData() {
      this.typeChooseList = [];
      this.$axios({
        method: "get",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `CommodityService/queryAllPublicGoods` // 接口地址
      }).then(res => {
        //console.log(res);
        this.tableData = res;
        this.oldTbaleData = res;
        res.map(item => {
          if (!this.typeChooseList.includes(item.commodityType)) {
            this.typeChooseList.push(item.commodityType);
          }
        });
        // this.chooseType = this.typeChooseList[0];
        this.choosetTypeChange(this.chooseType);
        // this.typeChooseList = res.map(item => {
        //   return item.commodityType;
        // });
        // //console.log(typeList);

        // }
      });
    }
  }
};
</script>

<style>
.clearfix {
  display: flex;
  justify-content: space-between;
}
.myuploadimgbxo{
  width: 100%;

display: flex;}
</style>